// oxlint-disable no-unused-expressions
import { Alert, FormGroup, FormControl } from 'react-bootstrap';

import { Localization } from "@viamap/viamap2-common";
import { Parser } from '../managers/Parser';
import { Logger } from '@viamap/viamap2-common';
import { Utils } from '@viamap/viamap2-common';
import { importMenuStructure } from '../managers/ConfigData';
import {
    SelectionOptions, LayerInfo, ColumnMapping, LayerType, MitDataType,
    MappingPreference, MappingSpecElement, SheetAnalysisResult, SelectionListWithPrefs, ImportTransformation
} from '../common/managers/Types';

import { FormLabel } from 'react-bootstrap';
import { ApplicationStateContext, Feature } from 'src/states/ApplicationState';
import ReactDOM from 'react-dom';
import { LayerImportDuplicatesForm } from './LayerImportDuplicatesForm';
import { ProtectedFeature } from './ProtectedFeature';
import { MapitUtils } from 'src/managers/MapitUtils';
import { GlassButton } from './GlassButtons';
import { ADModalBody, ADModalFooter, AdvancedDragModal } from 'src/componentsUtils/AdvancedDragModal';
import { useContext, useEffect, useState } from 'react';
import { message } from './Message';

import { MIBIcon } from 'src/componentsUtils/MIBIcon';
type Props = {
    showWindow: boolean;
    sheetToImport: any;
    showStylingWindow?: boolean;
    analysisResult?: SheetAnalysisResult;
    defaultSelections: any;
    onFormSubmit: (layerInfo: LayerInfo) => void;
    onFormCancel: (info: any) => void;
    datasetname: string;
    filename?: string;
};

export function LayerImport(props: Props) {
    const { hasAccessToFeature } = useContext(ApplicationStateContext)
    const [alertMessage, setAlertMessage] = useState<string | null>(null)
    const [datasetname, setDatasetname] = useState(props.datasetname)
    const [importTransformation, setImportTransformation] = useState<ImportTransformation>();
    const [columnMapping, setColumnMapping] = useState<ColumnMapping>(props.defaultSelections && { ...props.defaultSelections })
    const [currentMaxLevel, setCurrentMaxLevel] = useState(props.defaultSelections ? props.defaultSelections.length : 0)
    const [currentSelections, setCurrentSelections] = useState(props.defaultSelections ? [...props.defaultSelections] : [])

    let _FormValidationState = {}

    const columnSelectionList = props.showWindow ? generateColumnSelectionList(props.sheetToImport) : null;
    const defaultSelections = props.showWindow && props.analysisResult ? generateDefaultSelections(props.analysisResult!) : null;

    // Copy default selections
    let colMap: ColumnMapping;
    colMap = {};
    defaultSelections && Object.keys(defaultSelections).forEach((m: string) => {
        let dflt = defaultSelections[m];
        if (dflt === undefined) {
            throw Utils.createErrorEventObject("Unexpectedly no default selection for item:" + m);
        }
        colMap = { ...colMap, [m]: dflt };
    });

    useEffect(() => {
        if (columnSelectionList == null ||
            props.analysisResult == null) {
            // ToDo: sheet error handling is done elsewhere. Should not be needed.
            // ToDo: does not seem to be used. Use global error message scheme in Utils.dispatchToErrorHandler
            setAlertMessage("Sheet could not be read")
        }
        if (colMap) {
            setColumnMapping(colMap);
        }
    }, [])



    function generateDefaultSelections(ar: SheetAnalysisResult): ColumnMapping {

        // Create default mapping.
        let defaultSelections: ColumnMapping = {};

        let ms: MitDataType[] = [
            MitDataType.Coord_WGS84_Lat,
            MitDataType.Coord_WGS84_Lon,
            MitDataType.Coord_UTM32_X,
            MitDataType.Coord_UTM32_Y,
            MitDataType.AdmReg_DK_MunicipalityId,
            MitDataType.AdmReg_DK_MunicipalityName,
            MitDataType.AdmReg_DK_RegionId,
            MitDataType.AdmReg_DK_RegionName,
            MitDataType.AdmReg_DK_ZipCodeId,
            MitDataType.AdmReg_DK_ZipCodeName,
            MitDataType.AdmReg_DK_ParishId,
            MitDataType.AdmReg_DK_ParishName,
            MitDataType.AdmReg_INT_CountryId,
            MitDataType.AdmReg_INT_CountryName,
            MitDataType.Address,
            MitDataType.Address2,
            MitDataType.Address3,
            MitDataType.Address4];

        ms && ms.forEach((obj2: MitDataType) => {
            let preferredColumnId = 0;
            let outputType = obj2;
            // Loop though columns of the input sheet
            ar?.columns?.forEach((item, row) => {
                let inputType = item.mitDataType;
                let pref = mappingValidity(inputType, outputType);
                if (!preferredColumnId && pref === MappingPreference.Preferred) {
                    preferredColumnId = row + 1; // one based column indexes
                }
            });
            // Set initial selection for row
            if (preferredColumnId) {
                defaultSelections[outputType] = preferredColumnId;
            }
        });
        return (defaultSelections);
    }

    function generateColumnSelectionList(sheet: any) {
        try {
            let result = Parser.generateColumnSelectionList(sheet);
            return (result);
        } catch (e: any) {
            Logger.logError("LayerImport", "analyze sheet", e.message);
            return (null);
        }
    }

    function generateColumListWithPreferences(mappingSpecElement: MappingSpecElement, analysisResult: SheetAnalysisResult): SelectionListWithPrefs {
        // Determine the applicability of each sheet column to the needed information element
        let result: SelectionListWithPrefs = [];
        analysisResult && analysisResult.columns.map((item, idx) => {
            let inputType = item.mitDataType;
            let outputType = mappingSpecElement.mitDataType;
            let pref = mappingValidity(inputType, outputType);
            result.push({
                value: (idx + 1).toString(), // one based column index
                label: item.columnLetter + " " + item.name,
                // display value
                comment: "",
                preference: pref
            });
        });
        return (result);
    }

    function mappingValidity(inputType: MitDataType, outPutType: MitDataType): MappingPreference {
        if (inputType === outPutType) {
            return (MappingPreference.Preferred);
        }
        if (inputType === MitDataType.Unknown) {
            return (MappingPreference.Unsuited);
        }
        return (MappingPreference.Neutral);
    }


    function nameOnChange(event: any) {
        setDatasetname(event.target.value)
    }

    function addtoColumnMap(columnMappingId: string, value: string) {
        // ToDo: refactor to send integer instead
        const intVal = Number.parseInt(value, 10);
        setColumnMapping({ ...columnMapping, [columnMappingId]: intVal });
    }

    function fieldSelectionChange(evt: any, columnMappingId: string) {
        let value = evt.target.value;
        addtoColumnMap(columnMappingId, value);
    }

    function onFormSubmit(e: any) {

        // hide this window
        e && e.preventDefault();

        // Figure out what the selected map type is. It is found in the leaf note in the options tree.
        let layerType = getLayerType();

        // Check that the type has a value (from user selection). Otherwise use default
        let colMap: ColumnMapping = columnMapping || {};
        columnMapping && defaultSelections && Object.keys(defaultSelections).forEach((m: any) => {
            if (!columnMapping[m]) {
                let dflt = defaultSelections[m];
                if (dflt === undefined) {
                    throw Utils.createErrorEventObject("Unexpectedly no default selection for item:" + m);
                }
                colMap = { ...colMap, [m]: dflt };
            }
        });


        // callback to parent
        const layerInfo: LayerInfo = {
            layerId: -1,
            datasetname: datasetname,
            filename: props.filename || datasetname,
            type: layerType,
            readonly: false,
            columnMapping: colMap,
            analysisResult: props.analysisResult!,
            styling: {},
            crs: layerType === LayerType.PointUTM32 ? 25832 : 4326,
            importTransformation: importTransformation
        };

        if (layerType.includes("Area")) {
            let areaType = layerType.split("Area")[1].toLowerCase().replace("codes", "code");
            let colKey = 0;
            Object.keys(colMap).forEach((key: string | number) => {
                if (String(key).toLowerCase().includes(areaType)) {
                    colKey = colMap[key];
                }
            });
            if (colKey > 0) {
                if (layerInfo?.analysisResult?.columnNames[colKey - 1] == importTransformation?.propertyToTransform) {
                    props.onFormCancel({});
                    message.info(Localization.getText("Transformation property cannot be the same as the area property"));
                    return;
                }
            }
        }



        props.onFormSubmit(layerInfo);
    }

    function getLayerType() {
        return currentSelections.filter((a) => a).at(-1);
    }


    function getSelectWithOptions(defaultValue: any, optionsArray: { value: any, label: any, disabled: any }[], name: string, onChange: any, caption: string, emptyValue: string) {
        const selectStyle = { color: defaultValue ? undefined : "#6c757d" };
        return (
            <FormGroup
                controlId="formControlsSelect"
                style={{ paddingLeft: "10%", paddingRight: "10%", marginTop: "12px", marginBottom: "12px" }}
            >
                <FormLabel style={{ marginBottom: "2px" }}>{Localization.getText(caption)}</FormLabel>
                <FormControl
                    as="select"
                    onChange={(e) => onChange(e)}
                    value={defaultValue}

                    style={selectStyle}
                >
                    <option
                        key="#Unselected#"
                        className="small"
                        value=''
                        style={{ color: "#6c757d" }}
                    >
                        {emptyValue.split("|").map((a) => Localization.getText(a)).join(" ")}
                    </option>
                    {optionsArray && optionsArray.filter((option) => {
                        return (option.disabled === undefined || hasAccessToFeature(option.disabled))
                    }).map((option) => (
                        <option key={option.label} className="small" value={option.value} style={{ color: "black" }}>{Localization.getText(option.label)}</option>
                    ))}
                </FormControl>
            </FormGroup>
        );
    }

    function getSelectWithOptionsAndPrefs(optionsArray: SelectionListWithPrefs, name: string, getValue: any, onChange: any, caption: string, emptyValue: string) {
        let selectedValue = getValue();
        // if (!selectedValue) {
        //     let defaultOption = optionsArray && optionsArray.find((option) => { return (option.preference === MappingPreference.Preferred); });
        //     selectedValue = defaultOption && defaultOption.value;
        // }
        const selectStyle = { color: selectedValue ? undefined : "#6c757d" };
        return (
            <FormGroup
                controlId="formControlsSelect"
                style={{ paddingLeft: "10%", paddingRight: "10%" }}
            >
                <FormLabel>{ }</FormLabel>
                <FormControl
                    name={name}
                    as="select"
                    onChange={(e) => onChange(e)}
                    value={selectedValue}

                    style={selectStyle}
                >
                    <option
                        key="#Unselected#"
                        className="small"
                        value=''
                        style={{ color: "#6c757d" }}
                    >
                        {emptyValue.split("|").map((a) => Localization.getText(a)).join(" ")}
                    </option>
                    {optionsArray && optionsArray.map((option) => (
                        <option
                            key={option.label}
                            className="small"
                            value={option.value}
                            style={{
                                color: "black",
                                backgroundColor: option.preference === MappingPreference.Preferred ? "green" :
                                    option.preference === MappingPreference.Unsuited ? "red" :
                                        "lightblue"
                            }}
                        // selected={option.preference === MappingPreference.Preferred ? true : false}        
                        >
                            {option.label}
                        </option>
                    ))}
                </FormControl>
            </FormGroup>
        );
    }


    function clearFormValidationState() {
        _FormValidationState = {};
    }


    function validateForm(): boolean {
        // ToDo: Make validation
        let result = true;
        Object.keys(_FormValidationState).map((key) => {
            let val = _FormValidationState[key];
            if (val === "error") {
                result = false;
            }
        });

        let getLeafNode: SelectionOptions | undefined = currentSelections && currentSelections.length > 0 && _getLeafNodeFromCurrentSelections(importMenuStructure, currentSelections);

        if (getLeafNode && getLeafNode.fieldselectionlist) {
            // Leaf node is field selection list. Check that all mandatory fields are selected
            getLeafNode.fieldselectionlist.forEach((obj) => {
                if (obj.mandatory) {
                    let found = false;
                    Object.keys(columnMapping || {}).forEach((key) => {
                        if (String(key) === String(obj.mitDataType) && columnMapping && columnMapping[key] && columnMapping[key] > 0) {
                            found = true;
                        }
                    });
                    if (!found) {
                        result = false;
                    }
                }
            });
        } else {
            result = false;
        }

        return result;
    }

    // ------------------------------------------------------------------


    function handleDismiss() {

    }


    // -------------------------------------
    function handleCancel() {
        setAlertMessage(null)

        // callback to parent
        props.onFormCancel(
            { message: "Cancelled by user" }
        );
    }



    function getDefaultDatasetName() {
        return ("");
    }

    // -------------------------------------
    // ToDo: does not seem to be used. Use global error message scheme in Utils.dispatchToErrorHandler
    function showAlerts() {
        return (alertMessage && (
            <Alert
                variant="danger"
                onClose={handleDismiss}
            >
                <h4 style={{ width: "100%" }}>
                    {alertMessage}
                </h4>
            </Alert>
        ));
    }

    function selectionOnChange(evt: any, thisLevelNo: number, hasChildren: boolean) {
        let value = evt.target.value;
        let newValues;
        let nextMax = thisLevelNo;
        if (value === "") {
            //  unset this and any values on following levels 
            newValues = [...currentSelections];
            newValues[thisLevelNo] = value;
            newValues.length = nextMax
        } else {
            // store the value;
            // increase the levelNo
            newValues = [...currentSelections];
            newValues[thisLevelNo] = value;
            if (hasChildren) {
                newValues[thisLevelNo + 1] = "";
                nextMax = thisLevelNo + 1;
            }
            newValues.length = nextMax
        }

        setCurrentMaxLevel(nextMax)
        setCurrentSelections(newValues)
    }

    function renderSelectLevel(thisLevelNo: number, currentValues: any[], optionsStructure: SelectionOptions) {
        console.assert(Boolean(optionsStructure), "optionsStructure expected");
        let heading = optionsStructure.heading;
        let optionsAtTopLevel = optionsStructure.options?.map((obj) => {
            return { label: obj.label, value: obj.value, disabled: obj.disabled };
        });
        let renderNextLevel: JSX.Element | null = null;
        let renderFieldSelections;

        let childStructure: SelectionOptions | undefined;
        let hasChildren: boolean =
            optionsStructure.options !== undefined
            || optionsStructure.fieldselectionlist !== undefined;
        if (currentMaxLevel >= thisLevelNo) {
            let sel = currentSelections[thisLevelNo];
            let f = optionsStructure.options && optionsStructure.options.find((obj) => {
                return (obj.value === sel);
            });
            childStructure = f && f.children;
            if (childStructure && childStructure.options && childStructure.options.length > 0) {
                renderNextLevel = renderSelectLevel(thisLevelNo + 1, currentValues, childStructure);
            }
            if (childStructure && childStructure.fieldselectionlist && childStructure.fieldselectionlist.length > 0) {
                hasChildren = true;
                childStructure && childStructure.fieldselectionlist.forEach((obj) => {
                    let columnPref = generateColumListWithPreferences(
                        obj,
                        props.analysisResult!);
                    let heading2 = obj.mitDataType;
                    let emptyValue2 = (obj.mandatory ? "please select" : "optionally select") + "|" + heading2;
                    let column1 = getSelectWithOptionsAndPrefs(
                        columnPref, heading2,
                        () => {
                            return columnMapping && columnMapping[obj.mitDataType];
                        },
                        (evt) => {
                            fieldSelectionChange(evt, obj.mitDataType)
                        },
                        heading2, emptyValue2);
                    renderFieldSelections = (
                        <div>
                            {renderFieldSelections}
                            {column1}
                        </div>
                    );
                });
            }

        }

        let emptyValue = "please select" + "|" + heading;
        let lvl = optionsAtTopLevel && getSelectWithOptions(
            currentValues[thisLevelNo],
            optionsAtTopLevel, heading,
            (evt) => {
                selectionOnChange(evt, thisLevelNo, hasChildren)
            }, heading, emptyValue);
        return (
            <div>
                {lvl}
                {renderFieldSelections}
                {renderNextLevel}
            </div>
        );
    }

    if (props.showWindow) {
        clearFormValidationState();

        let allSelects = renderSelectLevel(0, currentSelections, importMenuStructure);

        let commitbutton: JSX.Element | null = null;
        let cancelbutton: JSX.Element | null = null;

        commitbutton = <GlassButton onClick={onFormSubmit} disabled={!validateForm()} >{Localization.getText("Submit")}</GlassButton>;
        cancelbutton = <GlassButton onClick={handleCancel} >{Localization.getText("Cancel")}</GlassButton>;

        return ReactDOM.createPortal(
            <AdvancedDragModal
                PosDefault={{ left: "50%", top: "75px", width: "400px", transform: "TranslateX(-50%)" }}
                title={Localization.getText("Import")}
            >
                <ADModalBody>

                    {showAlerts()}
                    <FormGroup
                        controlId="formBasicText"
                        style={{ marginLeft: "10%", marginRight: "10%", marginBottom: "20px" }}
                    // validationState={getValidationStateForName()}
                    >
                        <FormLabel style={{ marginBottom: "2px" }}>{Localization.getText("Dataset name")}</FormLabel>
                        <FormControl
                            size="sm"
                            type="text"
                            value={datasetname ? datasetname : getDefaultDatasetName()}
                            placeholder={Localization.getText("Enter name of dataset")}
                            onChange={(e: any) => nameOnChange(e)}
                        />
                    </FormGroup>
                    {allSelects}
                    <div className="row">
                        <div className="col-sm-3" >{' '}</div>
                        <div className="col-sm-3" >{ }</div>
                        <div className="col-sm-3" >{ }</div>
                        <div className="col-sm-3" >{' '}</div>
                    </div>
                    <ProtectedFeature feature={Feature.AllowConsolidateDuplicates} contentsIfNoAccess={<></>}>
                        {MapitUtils.isAreaLayer(getLayerType()) ?
                            (
                                <AdvancedSettings>
                                    <LayerImportDuplicatesForm
                                        analysisResult={props.analysisResult!}
                                        onChange={(newState) =>
                                            LayerImportDuplicatesHandler(newState)
                                        }
                                    />
                                </AdvancedSettings>
                            ) : null}
                    </ProtectedFeature>
                </ADModalBody>
                <ADModalFooter>
                    {commitbutton}
                    {cancelbutton}
                </ADModalFooter>
            </AdvancedDragModal>
            , document.getElementById("Mit-MapOverlay") || document.body);
    } else {
        return (null);
    }

    function LayerImportDuplicatesHandler(newTransformation: ImportTransformation) {
        // alert("Transformation" + JSON.stringify(newTransformation, undefined, 3));
        setImportTransformation(newTransformation);
    }

}

function AdvancedSettings({ children }) {
    let [foldUd, setFoldUd] = useState(false)

    return (
        <>

            <GlassButton
                style={{ width: "50%", marginInline: "25%", marginTop: "10px" }}
                onClick={() =>
                    setFoldUd(!foldUd)
                }
            >
                {Localization.getText("Expander:AdvancedSettings")}<span className='mit-transformer' style={{ float: "right", transform: "Rotate(" + (foldUd ? "90deg" : "0deg") + ")" }}><MIBIcon icon="collapsable" /></span>
            </GlassButton>
            {foldUd ? children : null}

        </>
    )
}
export default LayerImport;


function _getLeafNodeFromCurrentSelections(
    optionsStructure: SelectionOptions,
    currentSelections: any[]
): any | undefined {
    if (!optionsStructure || !optionsStructure.options || currentSelections.length <= 0) {
        return undefined;
    }
    let selectedValue = currentSelections[0];
    let remainingSelections = currentSelections.slice(1);
    if (!selectedValue) {
        throw Utils.createErrorEventObject("Unexpectedly no selection found");
    }
    let selectedOption = optionsStructure.options && optionsStructure.options.find((obj) => {
        return (obj.value === selectedValue);
    });
    if (!selectedOption) {
        throw Utils.createErrorEventObject("Unexpectedly no option found for value:" + selectedValue);
    }
    if ((selectedOption as any).children.fieldselectionlist) {
        return (selectedOption as any).children;
    }
    if (selectedOption && selectedOption.children) {
        return _getLeafNodeFromCurrentSelections(selectedOption.children, remainingSelections);
    }
    throw Utils.createErrorEventObject("No leaf node found for selection");
}

